import React__default from 'react';
import PropTypes from 'prop-types';
import { ICON_SIZES } from '../../../constants/sizes.js';
import Loader from '../../Loader/index.js';
import { LoadingContainer } from './Button.styles.js';
import { BUTTON_VARIANT } from './Button.constants.js';

var ButtonContent = function ButtonContent(_ref) {
  var size = _ref.size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? undefined : _ref$variant;
  return React__default.createElement(LoadingContainer, {
    $variant: variant
  }, React__default.createElement(Loader, {
    size: ICON_SIZES[size]
  }));
};
ButtonContent.propTypes = {
  size: PropTypes.oneOf(Object.keys(ICON_SIZES)).isRequired,
  variant: PropTypes.oneOf(Object.values(BUTTON_VARIANT))
};

export { ButtonContent, ButtonContent as default };
//# sourceMappingURL=ButtonContent.js.map
